export default __webpack_public_path__ + "static/media/image11tum.4d6c9e31.jpg";